"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _qrCode = require("./qrCode");

var _qrCode2 = _interopRequireDefault(_qrCode);

var _functions = require("../utilities/functions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SAME_DEVICE = 1;
var ANOTHER_DEVICE = 2;

exports.default = {
  data: function data() {
    return {
      mode: null,
      defaultTries: 30,
      currentTries: null,
      sid: null,
      isError: false,
      message: null,
      interval: null,
      signing: false,
      isLoading: false,
      autoStartToken: ""
    };
  },


  /**
   * Mixins
   */
  mixins: [_qrCode2.default],

  /**
   * Mounted
   */
  mounted: function mounted() {
    //Mode selection is available only for mobile devices
    if (!this.isMobile()) {
      this.setAnotherDeviceMode();
    }
  },


  computed: {
    /**
     *
     * @returns {boolean}
     */
    hasTries: function hasTries() {
      return this.currentTries > 1;
    },


    /**
     * Is user signing
     * @returns {boolean}
     */
    isSigning: function isSigning() {
      return Boolean(this.sid);
    },


    /**
     * Auto start bank id app link
     * @returns {string}
     */
    autoStartUrl: function autoStartUrl() {
      return "https://app.bankid.com/?autostarttoken=" + this.autoStartToken + "&redirect=" + window.location.origin + "/login?sid=" + this.sid;
    },


    /**
     * Open bank id message
     * @returns {VueI18n.TranslateResult|string}
     */
    openBankIdMessage: function openBankIdMessage() {
      return !this.mode || this.isSameDeviceMode ? '' : this.$t("login.messages.open_bank_id");
    },


    /**
     * Open bank id failed message
     * @returns {VueI18n.TranslateResult|string}
     */
    bankIdFailedMessage: function bankIdFailedMessage() {
      return this.isSameDeviceMode ? this.$t("login.messages.bank_id_failed") : this.$t("login.messages.failed_to_scan");
    },


    /**
     * Is same device mode
     * Available only for mobile devices
     * @returns {boolean}
     */
    isSameDeviceMode: function isSameDeviceMode() {
      return this.isMobile() && this.mode === SAME_DEVICE;
    },


    /**
     * Is same device mode
     * Always true for non mobile devices
     * @returns {boolean}
     */
    isAnotherDeviceMode: function isAnotherDeviceMode() {
      return !this.isMobile() || this.mode === ANOTHER_DEVICE;
    }
  },

  methods: {
    /**
     * Start sign in
     */
    startSigning: function startSigning() {
      var _this = this;

      this.message = "";
      this.isLoading = true;
      axios.post("/login", { locale: this.$i18n.locale }).then(function (result) {
        _this.isLoading = false;
        _this.sid = result.data.sid;
        _this.isError = false;

        if (_this.isSameDeviceMode) {
          _this.autoStartToken = result.data.token;
        } else {
          _this.renderQrCode(document.getElementById("qr-code"), result.data.qrcode);
        }
        _this.message = _this.openBankIdMessage;
        _this.currentTries--;
      }).catch(function (error) {
        _this.isLoading = false;
        _this.handleError(error);
      });
    },


    /**
     * Start Auth checking
     */
    startAuthCheck: function startAuthCheck() {
      var _this2 = this;

      this.interval = setInterval(function () {
        _this2.checkIfAuthenticated();
      }, 1000);
    },


    /**
     * Check if user is authenticated
     */
    checkIfAuthenticated: function checkIfAuthenticated() {
      var _this3 = this;

      if (!this.sid) {
        return;
      }

      if (!this.hasTries) {
        this.message = this.bankIdFailedMessage;
        this.resetState();
        this.isError = true;

        return;
      }

      axios.post("/auth/isauthenticated", {
        sid: this.sid,
        locale: this.$i18n.locale
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.status === "ok") {
          clearInterval(_this3.interval);
          window.location.href = data.redirect;
        }

        if (data.qrcode) {
          _this3.renderQrCode(document.getElementById("qr-code"), data.qrcode);
        }
        _this3.currentTries--;
      }).catch(function (error) {
        _this3.handleError(error);
      });
    },


    /**
     * Handle response error
     * @param error
     */
    handleError: function handleError(error) {
      this.resetState();
      this.isError = true;
      this.message = _.get(error.response.data, "data.pno.0", error.response.data.message || this.$t("login.messages.bank_id_failed"));
    },


    /**
     * Reset state
     */
    resetState: function resetState() {
      clearInterval(this.interval);
      this.sid = null;
      this.currentTries = 0;
      this.autoStartToken = null;
      this.isLoading = false;
      this.removeQueryParams();
    },


    /**
     * Get sid from URL
     * @returns {string}
     */
    getSidFromUrl: function getSidFromUrl() {
      return new URLSearchParams(window.location.search).get("sid");
    },


    /**
     * Redirect to bank id app
     */
    redirectBankIdApp: function redirectBankIdApp() {
      window.location.replace(this.autoStartUrl);
    },


    /**
     * Remove query parameters
     */
    removeQueryParams: function removeQueryParams() {
      var urlWithoutParams = window.location.href.split("?")[0];
      window.history.pushState({ path: urlWithoutParams }, "", urlWithoutParams);
    },


    /**
     * Set same device mode
     */
    setSameDeviceMode: function setSameDeviceMode() {
      this.mode = SAME_DEVICE;
    },


    /**
     * Set another device mode
     */
    setAnotherDeviceMode: function setAnotherDeviceMode() {
      this.mode = ANOTHER_DEVICE;
    },


    isMobile: _functions.isMobile
  }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/mixins/authenticate.js
// module id = L9ui
// module chunks = 0 1